// extracted by mini-css-extract-plugin
module.exports = {"button":"InlineEditButton_button__2WKF8","rotate":"InlineEditButton_rotate__wKQfP","slideIn":"InlineEditButton_slideIn__2G6xJ","fadeIn":"InlineEditButton_fadeIn__1p5ct"};